export const awayProgressTypes = [
  {
    name: "antimatter",
    textName: "Антиматерия",
    rodTextName: "Антиматерии",
    gender: "f",
    isUnlocked: () => true,
  }, {
    name: "dimensionBoosts",
    textName: "Бусты Измерений",
    rodTextName: "Бустов Измерений",
    gender: "p",
    isUnlocked: () => true,
  }, {
    name: "antimatterGalaxies",
    textName: "Галактики Антиматерии",
    rodTextName: "Галактик Антиматерии",
    gender: "p",
    reference: ["galaxies"],
    isUnlocked: () => true,
  }, {
    name: "infinities",
    textName: "Бесконечности",
    rodTextName: "Бесконечностей",
    gender: "p",
    isUnlocked: () => PlayerProgress.infinityUnlocked(),
  }, {
    name: "infinityPoints",
    textName: "Очки Бесконечности",
    rodTextName: "Очков Бесконечности",
    gender: "p",
    isUnlocked: () => PlayerProgress.infinityUnlocked(),
  }, {
    name: "replicanti",
    textName: "Репликанты",
    rodTextName: "Репликантов",
    gender: "p",
    reference: ["replicanti", "amount"],
    isUnlocked: () => PlayerProgress.replicantiUnlocked() || PlayerProgress.eternityUnlocked(),
  }, {
    name: "replicantiGalaxies",
    textName: "Галактики Репликантов",
    rodTextName: "Галактик Репликантов",
    gender: "p",
    reference: ["replicanti", "galaxies"],
    isUnlocked: () => PlayerProgress.replicantiUnlocked() || PlayerProgress.eternityUnlocked(),
  }, {
    name: "eternities",
    textName: "Вечности",
    rodTextName: "Вечностей",
    gender: "p",
    isUnlocked: () => PlayerProgress.eternityUnlocked(),
  }, {
    name: "eternityPoints",
    textName: "Очки Вечности",
    rodTextName: "Очков Вечностей",
    gender: "p",
    isUnlocked: () => PlayerProgress.eternityUnlocked(),
  }, {
    name: "tachyonParticles",
    textName: "Тахион Частицы",
    rodTextName: "Тахион Частиц",
    gender: "p",
    reference: ["dilation", "tachyonParticles"],
    isUnlocked: () => PlayerProgress.dilationUnlocked() || PlayerProgress.realityUnlocked(),
  }, {
    name: "dilatedTime",
    textName: "Растянутое Время",
    rodTextName: "Растянутого Времени",
    gender: "n",
    reference: ["dilation", "dilatedTime"],
    isUnlocked: () => PlayerProgress.dilationUnlocked() || PlayerProgress.realityUnlocked(),
  }, {
    name: "timeTheorems",
    textName: "Временны́е Теоремы",
    rodTextName: "Временны́х Теорем",
    gender: "p",
    reference: ["timestudy", "theorem"],
    isUnlocked: () => PlayerProgress.dilationUnlocked() || PlayerProgress.realityUnlocked(),
  }, {
    name: "tachyonGalaxies",
    textName: "Галактики Тахионов",
    rodTextName: "Галактик Тахионов",
    gender: "p",
    reference: ["dilation", "totalTachyonGalaxies"],
    isUnlocked: () => PlayerProgress.dilationUnlocked() || PlayerProgress.realityUnlocked(),
  }, {
    name: "achievementAmount",
    textName: "Количество Достижений",
    rodTextName: "Количества Достижений",
    gender: "n",
    reference: ["achievementBits"],
    applyFn: x => x.map(b => countValuesFromBitmask(b)).sum(),
    isUnlocked: () => PlayerProgress.realityUnlocked(),
  }, {
    name: "realities",
    textName: "Реальности",
    rodTextName: "Реальностей",
    gender: "p",
    isUnlocked: () => PlayerProgress.realityUnlocked(),
  }, {
    name: "realityMachines",
    textName: "Машины Реальности",
    rodTextName: "Машин Реальности",
    gender: "p",
    reference: ["reality", "realityMachines"],
    isUnlocked: () => PlayerProgress.realityUnlocked(),
  }, {
    name: "blackHole",
    textName: "Чёрная Дыра",
    rodTextName: "Чёрных Дыр",
    gender: "f",
    isUnlocked: () => BlackHole(1).isUnlocked,
    // Functions as the visible option for both first & second BHs, never appears due to having no reference.
    appearsInAwayModal: false,
  }, {
    name: "firstBlackHole",
    textName: "Первая Чёрная Дыра",
    rodTextName: "Первой Чёрной Дыры",
    gender: "f",
    awayOption: "blackHole",
    reference: ["blackHole", "0", "activations"],
    isUnlocked: () => BlackHole(1).isUnlocked,
    classObjectReference: "black-hole",
    showOption: false,
  }, {
    name: "secondBlackHole",
    textName: "Вторая Чёрная Дыра",
    rodTextName: "Второй Чёрной Дыры",
    gender: "f",
    awayOption: "blackHole",
    reference: ["blackHole", "1", "activations"],
    isUnlocked: () => BlackHole(2).isUnlocked,
    classObjectReference: "black-hole",
    showOption: false,
  }, {
    name: "relicShards",
    textName: "Осколки Реликвий",
    rodTextName: "Осколков Реликвий",
    gender: "p",
    reference: ["celestials", "effarig", "relicShards"],
    isUnlocked: () => TeresaUnlocks.effarig.canBeApplied,
  }, {
    name: "celestialMemories",
    textName: "Воспоминания Божеств",
    rodTextName: "Воспоминаний Божеств",
    gender: "p",
    isUnlocked: () => VUnlocks.raUnlock.isUnlocked,
    // Functions as the visible option for all Memories, never appears due to having no reference.
    appearsInAwayModal: false,
  }, {
    name: "teresaMemories",
    textName: "Воспоминания Терезы",
    rodTextName: "Воспоминаний Терезы",
    gender: "p",
    awayOption: "celestialMemories",
    reference: ["celestials", "ra", "pets", "teresa", "memories"],
    isUnlocked: () => Ra.pets.teresa.isUnlocked && !Ra.pets.teresa.isCapped,
    showOption: false,
  }, {
    name: "effarigMemories",
    textName: "Воспоминания Эффарига",
    rodTextName: "Воспоминаний Эффарига",
    gender: "p",
    awayOption: "celestialMemories",
    reference: ["celestials", "ra", "pets", "effarig", "memories"],
    isUnlocked: () => Ra.pets.effarig.isUnlocked && !Ra.pets.effarig.isCapped,
    showOption: false,
  }, {
    name: "enslavedMemories",
    textName: "Воспоминания Безымянных",
    rodTextName: "Воспоминаний Безымянных",
    gender: "p",
    forcedName: "Nameless Memories",
    awayOption: "celestialMemories",
    reference: ["celestials", "ra", "pets", "enslaved", "memories"],
    isUnlocked: () => Ra.pets.enslaved.isUnlocked && !Ra.pets.enslaved.isCapped,
    showOption: false,
  }, {
    name: "vMemories",
    textName: "Воспоминания Ви",
    rodTextName: "Воспоминаний Ви",
    gender: "p",
    awayOption: "celestialMemories",
    reference: ["celestials", "ra", "pets", "v", "memories"],
    isUnlocked: () => Ra.pets.v.isUnlocked && !Ra.pets.v.isCapped,
    showOption: false,
  }, {
    name: "imaginaryMachines",
    textName: "Мнимые Машины",
    rodTextName: "Мнимых Машин",
    gender: "p",
    reference: ["reality", "imaginaryMachines"],
    isUnlocked: () => MachineHandler.isIMUnlocked,
  }, {
    name: "darkMatter",
    textName: "Тёмная Материя",
    rodTextName: "Тёмной Материи",
    gender: "f",
    reference: ["celestials", "laitela", "darkMatter"],
    isUnlocked: () => Laitela.isUnlocked,
  }, {
    name: "darkEnergy",
    textName: "Тёмная Энергия",
    rodTextName: "Тёмной Энергии",
    gender: "f",
    reference: ["celestials", "laitela", "darkEnergy"],
    isUnlocked: () => Laitela.isUnlocked,
  }, {
    name: "singularities",
    textName: "Сингулярности",
    rodTextName: "Сингулярностей",
    gender: "p",
    reference: ["celestials", "laitela", "singularities"],
    isUnlocked: () => Laitela.isUnlocked,
  }, {
    name: "realityShards",
    textName: "Осколки Реальности",
    rodTextName: "Осколков Реальности",
    gender: "p",
    reference: ["celestials", "pelle", "realityShards"],
    isUnlocked: () => Pelle.isDoomed,
  },
];
